import { httpBatchLink, httpLink, loggerLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { type inferRouterInputs, type inferRouterOutputs } from '@trpc/server';
import superjson from 'superjson';

import { type AppRouter } from '@/server/api/root';
import { getLoginAsUserIdForSuperAdmin } from './globals';

const IS_BATCH_ENABLED = false;

/** A set of type-safe react-query hooks for your tRPC API. */
export const api = createTRPCReact<AppRouter>();

/**
 * Create tRPC client configuration
 * This is used in the provider setup
 */
export function getTRPCClientConfig() {
    return {
        /**
         * Transformer used for data de-serialization from the server.
         */
        transformer: superjson,

        /**
         * Links used to determine request flow from client to server.
         */
        links: [
            loggerLink({
                enabled: (opts) =>
                    import.meta.env.DEV || (opts.direction === 'down' && opts.result instanceof Error),
            }),
            IS_BATCH_ENABLED
                ? httpBatchLink({
                      url: `/api/trpc`,
                      headers: () => {
                          const loginas = getLoginAsUserIdForSuperAdmin();
                          return loginas ? { loginas } : {};
                      },
                  })
                : httpLink({
                      url: `/api/trpc`,
                      headers: () => {
                          const loginas = getLoginAsUserIdForSuperAdmin();
                          return loginas ? { loginas } : {};
                      },
                  }),
        ],
    };
}

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
